module.exports = __webpack_public_path__ + "static/media/bigticket-bg.aed34996.jpg";